var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.77,38.29c-.38-.45-.76-.87-1.11-1.31-1.68-2.15-3.38-4.28-5.02-6.46-1.76-2.33-3.25-4.83-4.58-7.43-1.22-2.39-2.16-4.88-2.61-7.54-.43-2.52-.07-4.94.91-7.29.94-2.27,2.41-4.15,4.38-5.59C9.91,1.09,12.34.12,15.07.01c1.38-.05,2.73.09,4.07.42,3.33.82,5.92,2.71,7.85,5.49,1.68,2.42,2.4,5.14,2.31,8.09-.07,2.4-.83,4.62-1.72,6.81-1.03,2.52-2.37,4.88-3.86,7.15-1.33,2.03-2.78,3.97-4.25,5.9-1.12,1.46-2.34,2.84-3.52,4.26-.04.05-.1.09-.18.16ZM20.29,13.51c0-2.39-1.99-4.46-4.29-4.48-2.62-.01-4.6,1.93-4.66,4.46-.06,2.43,2.08,4.55,4.67,4.5,2.31-.04,4.29-2.09,4.28-4.49ZM.85,45.09c2.7,0,5.4,0,8.1,0,2.61,0,5.23,0,7.84,0,2.03,0,4.06-.03,6.09-.03,1.34,0,2.68.03,4.03.03,1.47,0,2.94-.01,4.41,0,.28,0,.29-.15.29-.35,0-.9,0-1.8,0-2.7,0-.49,0-.99,0-1.48H0v4.49c.34.02.6.04.85.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationEdit);
export default __webpack_public_path__ + "static/media/Location_Edit.e5a5da0d62cf1b0aa3ffd3b4278f7e94.svg";
export { ForwardRef as ReactComponent };